/**
 * Bread modal window
 */

import Vue from 'vue';
import axios from 'axios';

let breadModal;

if(document.getElementById('bread-modal')) {
	breadModal = new Vue({

		/** @type {String} root element selector */
		el: '#bread-modal',

		/** instance data */
		data() {
			return {
				active: false,
				loaded: false,

				title: '',
				content: [],
				image: '',
			}
		},

		/** instance created lifecycle hook */
		created() {
			const links = document.querySelectorAll('[data-bread-modal]');

			if(window.location.hash) {
				this.show(window.location.hash.replace('#', ''));
			}

			links.forEach((el, index) => {
				el.addEventListener('click', ev => {
					ev.preventDefault();
					this.show(ev.currentTarget.getAttribute('href').replace('#', ''));
				})
			});
		},

		/** @type {Object} instance methods */
		methods: {

			/**
			 * Show the modal window
			 *
			 * @param  {String} slug target bread slug
			 */
			show(slug) {
				this.active = true;

				let url = '/wp-json/slowdough/bread/';

				axios.get(url + slug)
					.then(response => this.populate(response.data))
					.catch(err => console.error('Error retrieving bread data'));
			},

			/**
			 * Poor man's data population
			 * @param {Object} data
			 */
			populate(data) {
				this.title = data.title;
				this.image = data.image;
				this.content = [];

				if(data.size) this.content.push(data.size);
				if(data.options) this.content.push(data.options);
				if(data.info) this.content.push(data.info);

				this.loaded = true;
			},

			/**
			 * Close the modal window
			 */
			close() {
				this.active = false;
				this.$nextTick(() => { this.loaded = false });
			}
		}
	});
}

export default breadModal;